import { VOICE_MODE, VOICE_SCREENS } from "../../constant/voiceMode";
import { iChatData } from "../../types";
import { Fragment } from "../../services/voice/liveTranscript";
import type { VoiceSession } from "./types";
import { voiceLog, now } from "./runtime";

const cityName = (city: any): string =>
  String(city?.destination_name || city?.destination_city || city?.city_name || city?.cityName?.split(",")[0] || "").trim();

const countryOf = (city: any): string => String(city?.city_country || city?.destination_country || "").trim();

const planDestination = (plan: any): string => {
  const seen = new Set<string>();
  const cities = (Array.isArray(plan?.destinationList) ? plan.destinationList : []).filter((city: any) => {
    const key = cityName(city).toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  const names: string[] = cities.map(cityName);
  if (names.length < 3) return names.join(" and ");
  const countries = new Set(cities.map((city: any) => countryOf(city).toLowerCase()));
  return countries.size === 1 && !countries.has("") ? countryOf(cities[0]) : names[0];
};

const showsFlightCards = (entry: iChatData): boolean =>
  typeof entry.flightResponse?.error !== "string" && Array.isArray(entry.flightResponse?.sectors) && entry.flightResponse.sectors.length > 0;

const showsHotelCards = (entry: iChatData): boolean =>
  Array.isArray(entry.hotelResponse) &&
  entry.hotelResponse.some((city: any) => typeof city?.error !== "string" && Array.isArray(city?.hotels) && city.hotels.length > 0);

export const openingScreen = (plan: any, chatData: iChatData[]): string => {
  const destination = plan ? planDestination(plan) : "";
  if (destination) return VOICE_SCREENS.plan(destination);
  const newest = chatData[chatData.length - 1];
  if (!newest) return VOICE_SCREENS.emptyChat;
  if (!newest.singleSelectedDestination && newest.destinationList?.length > 0) return VOICE_SCREENS.tripIdeas;
  if (showsFlightCards(newest)) return VOICE_SCREENS.flightResults;
  if (showsHotelCards(newest)) return VOICE_SCREENS.hotelResults;
  return VOICE_SCREENS.earlier;
};

export const endOpening = (session: VoiceSession, atMs = now() - (session.startedAt ?? now())) => {
  const opening = session.opening;
  if (!opening || opening.until !== null) return;
  opening.until = atMs;
  voiceLog("opening.ended", { liveSessionId: session.id, atMs });
};

export const joinsOpening = (session: VoiceSession, fragment: Fragment): boolean => {
  const opening = session.opening;
  if (!opening) return false;
  const continues = opening.spokeTo !== null && fragment.startMs - opening.spokeTo < VOICE_MODE.quietMs;
  if (opening.until !== null && fragment.startMs >= opening.until && !continues) {
    session.opening = null;
    return false;
  }
  opening.spokeTo = Math.max(opening.spokeTo ?? fragment.endMs, fragment.endMs);
  return true;
};
